import { createSlice } from '@reduxjs/toolkit';

import { getDeserializedState } from 'FRONTEND/utils/serialization';

const REDUCER_NAME = 'table';

const storedState = getDeserializedState()?.[REDUCER_NAME];
const initialState = {
  tableFilters: storedState?.tableFilters || {}, // Filters used by main SelectField (shared by all tables), managed by location. (e.g. { /consultation/: { status: 'active' } })
  tableSearchQuery: storedState?.tableSearchQuery || {}, // Search query of main search input (shared by all tables), managed by location. (e.g. { /consultation/: 'search term' })
  isSearchDebouncing: false, // Used for artificial loading when debouncing search input.
  // Additional context for each table. Currently only "consultation" table supports this, but it's fully modular key-value store for any table in the future.
  tableContext: storedState?.tableContext || {},
};

const tableSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    updateTableFilters: (state, action) => {
      const { tableName, filters } = action.payload;
      state.tableFilters[tableName] = filters;
    },
    startTableSearch: (state) => {
      state.isSearchDebouncing = true;
    },
    applyTableSearch(state, action) {
      const { tableName, searchQuery } = action.payload;
      state.tableSearchQuery[tableName] = searchQuery;
      state.isSearchDebouncing = false;
    },
    updateTableContext(state, action) {
      // Allows storing all sorts of contextual information for each table.
      // Fully modular so it can be adaptable to other tables in the future.
      const { tableName, contextObject } = action.payload;
      state.tableContext[tableName] = {
        ...state.tableContext[tableName],
        ...contextObject,
      };
    },
  },
});

export const { updateTableFilters, startTableSearch, applyTableSearch, updateTableContext } = tableSlice.actions;

export default tableSlice.reducer;
